export const filterAll41ProjectReportsData = (obj: any) => {
  const all41ReportArray: any = [];
  obj.All41ProjectReports.forEach((data:any) => {
    all41ReportArray.push(formateArray(data))
  })
  return all41ReportArray;
}

const filterColumnNames = ["prop_num", "property_name", "ts_comments", "template", "screen_resolution", "ts_live", "static", "custom_style", "zip_postal"]

/* tslint:disable */
export const formateArray = (data: any) => {
  const sortedArr: any = {};
  for (const propertyName in data) {
    if (filterColumnNames.indexOf(propertyName) !== -1) {
      // loop through properties
      if (propertyName === "property_name" || propertyName === "ts_comments") {
        if (data[propertyName]) {
          sortedArr[propertyName] = data[propertyName].trim();
        }
        else {
          sortedArr[propertyName] = ""
        }
      } else {
        sortedArr[propertyName] = data[propertyName];
      }
    }
  }
  return sortedArr;
}









// WEBPACK FOOTER //
// ./src/store/all41Projects/all41ProjectReportsFilter.ts